<template>
  <div class="main">
    <div v-if="data.length==0" class='jiazai'>
      加载数据中……
    </div>
    <div v-if="data.lastqi!==0">
      <div>
        <div class="tb">
          <ul>
            <span style="float: left;line-height: 2rem;">位置</span>
            <li v-for="(v,i) in wz" :key="i" :class="wzi[i]?'act':''" @click="wzi[i]=!wzi[i]">{{ v }}</li>
            <li style="background: #099909;color: #fff;" @click="wzi=[false,false,false,false,false,false,false]">清空</li>
          </ul>
          <ul>
            <span style="float: left;line-height: 2rem;">条件</span>
            <li style="padding: 2px 10px;" v-for="(v,i) in sx" :key="i" :class="sxi[i]?'act':''" @click="sxi[i]=!sxi[i]">{{ v }}</li>
            <li style="background: #099909;color: #fff;" @click="sxi=[false,false,false,false,false,false,false,false,false,false,false,false]">清空</li>
          </ul>
        </div>
      </div>
        <div v-for='v in data' :key="v" class='his-line'>
          <p style="text-align: left;font-size: .8rem;line-height: 1.5rem;">{{v.qishu}}期（开奖时间：{{v.date}}）</p>
          <ul>
              <li v-for="(n,j) in v.num.split(',')" :key="j" v-show="j<6" :style="sty(j,v.shengxiao.split(',')[j])?'opacity: 1;':'opacity: 0.1;'">
                  <div :class="'nb n'+n">{{n}}</div>
                  <p class="pro">{{v.shengxiao.split(',')[j]}}</p>
              </li>
              <li style="width: 9%;border: none;">
                  <div style="line-height: 32px;">特</div>
              </li>
              <li :style="sty(6,v.shengxiao.split(',')[6])?'opacity: 1;':'opacity: 0.1;'">
                  <div :class="'nb n'+v.num.split(',')[6]">{{v.num.split(',')[6]}}</div>
                  <p class="pro">{{v.shengxiao.split(',')[6]}}</p>
              </li>
          </ul>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'History',
  props: {
    data: Array
  },
  data(){
    return{
      wz:['平一','平二','平三','平四','平五','平六','特码'],
      wzi:[false,false,false,false,false,false,false],
      sx:['鼠','牛','虎','兔','龙','蛇','马','羊','猴','鸡','狗','猪'],
      sxi:[false,false,false,false,false,false,false,false,false,false,false,false],
    }
  },
  methods:{
    sty(i,s){
      if(this.wzi.indexOf(true) >= 0){
        if(this.wzi[i]==false ){
          return false;
        }
      }
      if(this.sxi.indexOf(true) >= 0){
        if(this.sxi[this.sx.indexOf(s)]==false ){
          return false;
        }
      }
      return true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tb{
  background: #ff0;
  padding: 5px 0;
}
.tb ul{
  display: flex;
  flex-wrap: wrap;
}
.tb li{
  border: 1px solid #ccc;
  border-radius: 3px;
  margin: 3px;
  padding: 2px 5px;
  font-size: .8rem;
  cursor: pointer;
}
.tb .act{
  background: #f00;
  color: #fff;
  border-color: #ff0000;
}
.n01,.n02,.n07,.n08,.n12,.n13,.n18,.n19,.n23,.n24,.n29,.n30,.n34,.n35,.n40,.n45,.n46{
	background: #f00;
}
.n03,.n04,.n09,.n10,.n14,.n15,.n20,.n25,.n26,.n31,.n36,.n37,.n41,.n42,.n47,.n48{
	background: #3fa2ff;
}
.n05,.n06,.n11,.n16,.n17,.n21,.n22,.n27,.n28,.n32,.n33,.n38,.n39,.n43,.n44,.n49{
	background: #1aa91a;
}
.his-line{
    padding:2px;
}
.his-qid {
    color: #8b8b8b;
    width: 20%;
    font-size: 14px;
    width: 20%;
    line-height: 20px;
}
.his-qid .qn{
    font-size: 16px;
    line-height: 32px;
    color: #373737;
    font-weight: 600;
    letter-spacing: 1px;
}
.his-nb{
    width: 80%;
}
.his-line ul {
    display: flex;
    justify-content: space-around;
}
.his-line ul li{
  width: 13%;
  border: .5px solid #656565;
}
.his-line ul li div{
    font-size: 16px;
}
.pro {
    font-size: 14px;font-weight: 900;
}
.nb{
  color: #fff;
    width: 100%;
    height: 26px;
    background-size: contain;
    line-height: 26px;
    font-weight: 600;
}
</style>
